// Fetches a same-origin HTML fragment for a block the page fills after it loads. Resolves
// to the markup, or to null when there is nothing to show: a 204, an error status, a failed
// request, or a redirect. A redirect is an error here on purpose: a lost session redirects
// to the join page, which must not land inside the block.
export const fetchFragment = async (path: string): Promise<string | null> => {
  try {
    const response = await fetch(path, {
      credentials: "same-origin",
      redirect: "error",
      headers: { Accept: "text/html" },
    })
    return response.ok && response.status !== 204 ? await response.text() : null
  } catch {
    return null
  }
}
